import {
  Container,
  Grid,
  Box,
  TextField,
  Button,
  Snackbar,
  Slide,
  Fade,
  InputAdornment,
  useTheme,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { useState, useEffect, useRef } from "react";

import MuiAlert from "@material-ui/lab/Alert";
import Axios from "axios";
import { Helmet } from "react-helmet-async";
import { Loading } from "../../components/shared/loading";
import { TypingQuote } from "../../components/shared/TypingQuote";
import { HeroParticles } from "../../components/shared/HeroParticles";
import PlaceIcon from "@material-ui/icons/Place";
import EmailIcon from "@material-ui/icons/Email";
import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import YouTubeIcon from "@material-ui/icons/YouTube";
import PhoneIcon from "@material-ui/icons/Phone";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import WorkOutlineIcon from "@material-ui/icons/WorkOutline";
import ChatBubbleOutlineIcon from "@material-ui/icons/ChatBubbleOutline";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";

const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  "@keyframes heroFadeUp": {
    from: { opacity: 0, transform: "translateY(24px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
  "@keyframes heroExpand": {
    from: { width: 0, opacity: 0 },
    to: { width: 90, opacity: 1 },
  },
  "@keyframes heroShimmerSweep": {
    "0%": { backgroundPosition: "-200% center" },
    "100%": { backgroundPosition: "200% center" },
  },
  heroSection: {
    position: "relative",
    overflow: "hidden",
    minHeight: "45vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #1a001a 0%, #2d002d 50%, #1a001a 100%)",
  },
  heroContent: {
    position: "relative",
    zIndex: 1,
    textAlign: "center",
    color: "#ffffff",
    padding: "40px 20px",
    maxWidth: 700,
  },
  heroTitle: {
    fontSize: "clamp(1.8rem, 4vw, 2.5rem)",
    fontWeight: 700,
    marginBottom: 10,
    backgroundImage:
      "linear-gradient(90deg, #ffffff 0%, #e0b8e0 25%, #c77dc7 50%, #e0b8e0 75%, #ffffff 100%)",
    backgroundSize: "200% auto",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
    color: "transparent",
    animation:
      "$heroFadeUp 0.9s cubic-bezier(0.22, 1, 0.36, 1) 0.15s both, $heroShimmerSweep 5s linear infinite",
  },
  heroDivider: {
    width: 90,
    height: 3,
    background:
      "linear-gradient(90deg, transparent, #c77dc7 30%, #e0b8e0 50%, #c77dc7 70%, transparent)",
    margin: "16px auto",
    borderRadius: 2,
    animation: "$heroExpand 0.9s cubic-bezier(0.22, 1, 0.36, 1) 0.55s both",
  },
  heroSubtitle: {
    fontSize: "clamp(0.85rem, 1.5vw, 1rem)",
    fontWeight: 400,
    opacity: 0.9,
    maxWidth: 500,
    margin: "0 auto",
    lineHeight: 1.5,
    animation: "$heroFadeUp 0.9s cubic-bezier(0.22, 1, 0.36, 1) 0.5s both",
  },
  section: {
    padding: "60px 0 80px",
    background: "#fafafa",
    position: "relative",
    overflow: "hidden",
    [theme.breakpoints.down("xs")]: {
      padding: "40px 0 60px",
    },
  },
  sectionTitle: {
    fontSize: "1.6rem",
    fontWeight: 700,
    color: "#4c004c",
    textAlign: "center",
    marginBottom: 8,
    letterSpacing: "-0.01em",
  },
  sectionSubtitle: {
    fontSize: "0.9rem",
    color: "#666",
    textAlign: "center",
    maxWidth: 480,
    margin: "0 auto 40px",
    lineHeight: 1.6,
  },

  // ── Form Card ──
  formCard: {
    position: "relative",
    background:
      "linear-gradient(160deg, #ffffff 0%, #fdfafd 55%, #f8eef8 100%)",
    borderRadius: 20,
    padding: "36px 32px",
    border: "1px solid rgba(76,0,76,0.08)",
    boxShadow: "0 12px 40px rgba(76,0,76,0.08)",
    overflow: "hidden",
    height: "100%",
    [theme.breakpoints.down("xs")]: {
      padding: "28px 22px",
      borderRadius: 16,
    },
    "&::before": {
      content: '""',
      position: "absolute",
      top: -80,
      right: -80,
      width: 240,
      height: 240,
      borderRadius: "50%",
      background:
        "radial-gradient(circle, rgba(199,125,199,0.22), transparent 70%)",
      filter: "blur(40px)",
      pointerEvents: "none",
    },
  },
  formLabel: {
    position: "relative",
    zIndex: 1,
    fontSize: "0.62rem",
    fontWeight: 700,
    color: "#9b3b9b",
    textTransform: "uppercase",
    letterSpacing: "1.8px",
    marginBottom: 8,
  },
  formTitle: {
    position: "relative",
    zIndex: 1,
    fontSize: "1.4rem",
    fontWeight: 700,
    color: "#4c004c",
    marginBottom: 6,
    letterSpacing: "-0.01em",
  },
  formSubtitle: {
    position: "relative",
    zIndex: 1,
    fontSize: "0.83rem",
    color: "#666",
    marginBottom: 26,
    lineHeight: 1.65,
  },
  textField: {
    position: "relative",
    zIndex: 1,
    "& .MuiOutlinedInput-root": {
      borderRadius: 12,
      backgroundColor: "rgba(255,255,255,0.7)",
      fontSize: "0.88rem",
      transition: "all 0.3s cubic-bezier(0.22, 1, 0.36, 1)",
      "& fieldset": {
        borderColor: "rgba(76,0,76,0.12)",
        transition: "border-color 0.3s ease, border-width 0.3s ease",
      },
      "&:hover fieldset": {
        borderColor: "rgba(76,0,76,0.32)",
      },
      "&.Mui-focused": {
        backgroundColor: "#ffffff",
        boxShadow: "0 0 0 4px rgba(155,59,155,0.08)",
        "& fieldset": {
          borderColor: "#4c004c",
          borderWidth: 1.5,
        },
      },
    },
    "& .MuiOutlinedInput-input": {
      padding: "13px 12px",
    },
    "& .MuiOutlinedInput-multiline": {
      padding: "13px 12px",
      "& textarea": { padding: 0 },
    },
    "& .MuiInputLabel-root": {
      fontSize: "0.85rem",
      color: "#888",
      "&.Mui-focused": { color: "#4c004c" },
    },
    "& .MuiInputAdornment-root svg": {
      color: "#9b3b9b",
      fontSize: 20,
      transition: "color 0.3s ease",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiInputAdornment-root svg": {
      color: "#4c004c",
    },
  },
  submitButton: {
    background: "linear-gradient(135deg, #4c004c 0%, #6b1b6b 100%)",
    color: "#ffffff",
    padding: "14px 36px",
    borderRadius: 14,
    fontSize: "0.9rem",
    fontWeight: 600,
    textTransform: "none",
    letterSpacing: "0.2px",
    width: "100%",
    boxShadow: "0 8px 22px rgba(76,0,76,0.28)",
    transition: "all 0.3s cubic-bezier(0.22, 1, 0.36, 1)",
    "& .MuiButton-endIcon": {
      transition: "transform 0.3s cubic-bezier(0.22, 1, 0.36, 1)",
      marginLeft: 10,
    },
    "&:hover": {
      background: "linear-gradient(135deg, #6b1b6b 0%, #9b3b9b 100%)",
      transform: "translateY(-2px)",
      boxShadow: "0 14px 32px rgba(76,0,76,0.4)",
    },
    "&:hover .MuiButton-endIcon": {
      transform: "translateX(5px)",
    },
    "&:disabled": {
      background: "#cccccc",
      boxShadow: "none",
      color: "#ffffff",
    },
  },
  formFootnote: {
    position: "relative",
    zIndex: 1,
    marginTop: 14,
    textAlign: "center",
    fontSize: "0.72rem",
    color: "#888",
    letterSpacing: "0.2px",
    "& strong": {
      color: "#4c004c",
      fontWeight: 600,
    },
  },

  // ── Info Card ──
  infoCard: {
    position: "relative",
    background:
      "linear-gradient(160deg, #4c004c 0%, #2d002d 60%, #1a001a 100%)",
    borderRadius: 20,
    padding: "36px 32px",
    height: "100%",
    overflow: "hidden",
    boxShadow: "0 16px 50px rgba(76,0,76,0.25)",
    [theme.breakpoints.down("xs")]: {
      padding: "30px 22px",
      borderRadius: 16,
    },
    "&::before": {
      content: '""',
      position: "absolute",
      width: 320,
      height: 320,
      borderRadius: "50%",
      top: -120,
      right: -120,
      background:
        "radial-gradient(circle, rgba(199,125,199,0.4), transparent 70%)",
      filter: "blur(50px)",
      pointerEvents: "none",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      width: 280,
      height: 280,
      borderRadius: "50%",
      bottom: -120,
      left: -120,
      background:
        "radial-gradient(circle, rgba(155,59,155,0.32), transparent 70%)",
      filter: "blur(50px)",
      pointerEvents: "none",
    },
  },
  infoLabel: {
    position: "relative",
    zIndex: 1,
    fontSize: "0.62rem",
    fontWeight: 700,
    color: "#c77dc7",
    textTransform: "uppercase",
    letterSpacing: "2.2px",
    marginBottom: 8,
  },
  infoTitle: {
    position: "relative",
    zIndex: 1,
    fontSize: "1.7rem",
    fontWeight: 700,
    color: "#ffffff",
    letterSpacing: "-0.02em",
    marginBottom: 8,
    lineHeight: 1.2,
  },
  infoIntro: {
    position: "relative",
    zIndex: 1,
    fontSize: "0.85rem",
    color: "rgba(255,255,255,0.72)",
    lineHeight: 1.65,
    marginBottom: 24,
  },
  infoTile: {
    position: "relative",
    zIndex: 1,
    display: "flex",
    alignItems: "flex-start",
    gap: 14,
    padding: "14px 14px",
    borderRadius: 14,
    marginBottom: 10,
    border: "1px solid rgba(255,255,255,0.08)",
    background: "rgba(255,255,255,0.04)",
    backdropFilter: "blur(6px)",
    transition: "all 0.3s cubic-bezier(0.22, 1, 0.36, 1)",
    cursor: "pointer",
    "&, &:hover, &:focus, &:active, &:visited": {
      color: "#ffffff",
      textDecoration: "none",
    },
    "&:hover": {
      background: "rgba(255,255,255,0.08)",
      borderColor: "rgba(199,125,199,0.3)",
      transform: "translateX(4px)",
    },
    "&:hover $infoTileIcon": {
      background: "rgba(199,125,199,0.28)",
      color: "#ffffff",
      transform: "scale(1.05)",
    },
  },
  infoTileIcon: {
    width: 40,
    height: 40,
    borderRadius: 11,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(199,125,199,0.16)",
    color: "#e0b8e0",
    flexShrink: 0,
    transition: "all 0.3s cubic-bezier(0.22, 1, 0.36, 1)",
    "& svg": { fontSize: 19 },
  },
  infoTileLabel: {
    fontSize: "0.6rem",
    fontWeight: 600,
    color: "rgba(199,125,199,0.92)",
    textTransform: "uppercase",
    letterSpacing: "1.5px",
    marginBottom: 3,
  },
  infoTileText: {
    fontSize: "0.82rem",
    color: "rgba(255,255,255,0.92)",
    lineHeight: 1.6,
    fontWeight: 400,
  },
  socialRow: {
    position: "relative",
    zIndex: 1,
    display: "flex",
    flexWrap: "wrap",
    gap: 10,
    marginTop: 22,
    paddingTop: 22,
    borderTop: "1px solid rgba(255,255,255,0.1)",
  },
  socialButton: {
    width: 42,
    height: 42,
    borderRadius: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(255,255,255,0.08)",
    border: "1px solid rgba(255,255,255,0.12)",
    transition: "all 0.3s cubic-bezier(0.22, 1, 0.36, 1)",
    "&:hover": {
      background: "rgba(199,125,199,0.25)",
      borderColor: "rgba(199,125,199,0.5)",
      transform: "translateY(-3px)",
      boxShadow: "0 8px 20px rgba(199,125,199,0.28)",
    },
    "& svg": {
      fontSize: 18,
      color: "#ffffff",
    },
  },
  quoteSection: {
    background: "linear-gradient(135deg, #6b1b6b 0%, #4a0e4a 100%)",
    borderRadius: "12px",
    padding: "28px 24px",
    marginTop: 32,
    textAlign: "center",
  },
  quoteText: {
    fontSize: "0.9rem",
    color: "#ffffff",
    lineHeight: 1.6,
    fontStyle: "italic",
    maxWidth: 700,
    margin: "0 auto 12px",
  },
  quoteAuthor: {
    color: "#ffffff",
    fontSize: "0.8rem",
    fontWeight: 600,
    opacity: 0.9,
  },
}));

export const Contact = () => {

  const nameRef = useRef(null);
  const emailRef = useRef(null);
  const mobileRef = useRef(null);
  const subjectRef = useRef(null);
  const messageRef = useRef(null);

  const theme = useTheme();
  const classes = useStyles();
  const [metaTitle, setMetaTitle] = useState("");
  const [metaDesc, setMetaDesc] = useState("");
  const [metaKeywords, setMetaKeywords] = useState("");
  const [isloading, setIsloading] = useState(true);
  //const [checked, setChecked] =  useState(true);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mob, setMob] = useState("");
  const [subj, setSubj] = useState("");
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState(0);
  const [disablebutton, setDisablebutton] = useState(false);

  const [snackBar, setSnackBar] = useState(false);
  const [snackBarMsg, setSnackBarMsg] = useState("success");
  const [snackBarType, setSnackBarType] = useState("Invalid");

  const openSnkbar = (type, msg) => {
    setSnackBarMsg(msg);
    setSnackBarType(type);
    setSnackBar(true);
  };

  const handleClick = () => {
    const anchor = document.querySelector("#back-to-top-anchor");

    if (anchor) {
      anchor.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  useEffect(() => {
    getMetaData();
  }, []);

  const getMetaData = () => {
    const formData = new FormData();
    formData.append("page", 5);
    Axios.post("/api/getmetadata", formData, {
      headers: { headKey: headKey },
    }).then((res) => {
      if (res.data.status) {
        setMetaTitle(res.data.data.meta_title);
        setMetaKeywords(res.data.data.meta_keywords);
        setMetaDesc(res.data.data.meta_desc);
        setIsloading(false);
        handleClick();
      }
    });
  };

  const onSubmit = () => {
    setErr(0);
    if (name == "") {
      setErr(1);
       
      if (nameRef.current) {
          nameRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      openSnkbar("error", "Please Enter Your Name....");
    } else if (!email.includes("@")) {
      setErr(2);
      if (emailRef.current) {
        emailRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      openSnkbar("error", "Please Enter a Valid Email-Id....");
    } else if (mob.length > 15 || mob.length < 9 || /[a-zA-Z]/.test(mob)) {
      setErr(3);
      if (mobileRef.current) {
        mobileRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      openSnkbar("error", "Please Enter a Valid Mobile Number....");
    } else if (subj == "") {
      setErr(4);
      if (subjectRef.current) {
        subjectRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      openSnkbar("error", "Please Enter Your Subject....");
    } else if (msg == "") {
      setErr(5);
      if (messageRef.current) {
        messageRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      openSnkbar("error", "Please Enter Your Message....");
    } else {
      openSnkbar("warning", "Please wait.....");
      setDisablebutton(true);
      const formData = new FormData();
      formData.append("name", name);
      formData.append("email", email);
      formData.append("mob", mob);
      formData.append("sub", subj);
      formData.append("msg", msg);
      Axios.post("/api/contactnow", formData, {
        headers: { headKey: headKey },
      }).then((res) => {
        if (res.data.status) {
          setDisablebutton(false);
          setName("");
          setEmail("");
          setMob("");
          setSubj("");
          setMsg("");
          openSnkbar("success", res.data.msg);
        } else {
          setDisablebutton(false);
          openSnkbar("error", "Something went wrong... try later.");
        }
      });
    }
  };

  
  return (
    <div>
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDesc} />
        <meta name="keywords" content={metaKeywords}></meta>
      </Helmet>
      {/* Hero Section */}
      <Box className={classes.heroSection}>
        <HeroParticles id="contact-hero-particles" />
        <Box className={classes.heroContent}>
          <Typography className={classes.heroTitle}>
            Contact Us
          </Typography>
          <Box className={classes.heroDivider} />
          <Typography className={classes.heroSubtitle}>
            Discover How We Can Fulfill Your Diverse Software Needs with Excellence
          </Typography>
        </Box>
      </Box>

      {isloading ? (
        <Loading />
      ) : (
        <Box className={classes.section}>
          <Container maxWidth="lg">
            {/* Snackbar for notifications */}
            <Snackbar
              open={snackBar}
              autoHideDuration={4000}
              onClose={() => setSnackBar(false)}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
              <Alert
                onClose={() => setSnackBar(false)}
                severity={snackBarType}
                style={{ color: snackBarType === "warning" ? "black" : "white" }}
              >
                {snackBarMsg}
              </Alert>
            </Snackbar>

            <Slide direction="up" in={true} timeout={800}>
              <Box>
                <Typography className={classes.sectionTitle}>
                  Get in Touch
                </Typography>
                <Typography className={classes.sectionSubtitle}>
                  We're here to listen, assist, and partner with you
                </Typography>
              </Box>
            </Slide>

            <Grid container spacing={4} alignItems="stretch">
              {/* Contact Form */}
              <Grid item xs={12} md={7}>
                <Fade in={true} timeout={1000}>
                  <Box className={classes.formCard}>
                    <Typography className={classes.formLabel}>
                      Quick Form
                    </Typography>
                    <Typography className={classes.formTitle}>
                      Tell us about your project
                    </Typography>
                    <Typography className={classes.formSubtitle}>
                      Fill out the form and one of our consultants will reach out within 24 hours.
                    </Typography>

                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          ref={nameRef}
                          id="name"
                          label="Your Name"
                          variant="outlined"
                          error={err === 1}
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          required
                          fullWidth
                          className={classes.textField}
                          InputLabelProps={{ shrink: true }}
                          placeholder="John Doe"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <PersonOutlineIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          ref={emailRef}
                          id="email"
                          label="Email Address"
                          variant="outlined"
                          error={err === 2}
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                          fullWidth
                          className={classes.textField}
                          InputLabelProps={{ shrink: true }}
                          placeholder="john@example.com"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <EmailIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          ref={mobileRef}
                          id="mobile"
                          label="Mobile Number"
                          variant="outlined"
                          error={err === 3}
                          value={mob}
                          onChange={(e) => setMob(e.target.value)}
                          required
                          fullWidth
                          className={classes.textField}
                          InputLabelProps={{ shrink: true }}
                          placeholder="+91 98765 43210"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <PhoneIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          ref={subjectRef}
                          id="subject"
                          label="Enquiry For"
                          variant="outlined"
                          error={err === 4}
                          value={subj}
                          onChange={(e) => setSubj(e.target.value)}
                          required
                          fullWidth
                          className={classes.textField}
                          InputLabelProps={{ shrink: true }}
                          placeholder="Web, App, ERP..."
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <WorkOutlineIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          ref={messageRef}
                          id="message"
                          label="Your Message"
                          variant="outlined"
                          error={err === 5}
                          value={msg}
                          multiline
                          rows={4}
                          onChange={(e) => setMsg(e.target.value)}
                          required
                          fullWidth
                          className={classes.textField}
                          InputLabelProps={{ shrink: true }}
                          placeholder="Tell us about your project requirements..."
                          InputProps={{
                            startAdornment: (
                              <InputAdornment
                                position="start"
                                style={{ alignSelf: "flex-start", marginTop: 4 }}
                              >
                                <ChatBubbleOutlineIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Button
                          onClick={onSubmit}
                          disabled={disablebutton}
                          className={classes.submitButton}
                          endIcon={!disablebutton && <ArrowForwardIcon />}
                        >
                          {disablebutton ? "Sending..." : "Send Message"}
                        </Button>
                        <Typography className={classes.formFootnote}>
                          We typically respond within <strong>24 hours</strong>.
                          Your details stay private.
                        </Typography>
                      </Grid>
                    </Grid>
                  </Box>
                </Fade>
              </Grid>

              {/* Contact Info */}
              <Grid item xs={12} md={5}>
                <Fade in={true} timeout={1200}>
                  <Box className={classes.infoCard}>
                    <Typography className={classes.infoLabel}>
                      Get in Touch
                    </Typography>
                    <Typography className={classes.infoTitle}>
                      Let's talk.
                    </Typography>
                    <Typography className={classes.infoIntro}>
                      Whether you have a project, a question, or just want to
                      chat - we're here to listen.
                    </Typography>

                    <a
                      href="https://maps.google.com/?q=201,+Reliance+Avans+Bliss,+Jayabheri+Enclave,+Gachibowli,+Hyderabad,+Telangana+500032"
                      target="_blank"
                      rel="noopener noreferrer"
                      className={classes.infoTile}
                    >
                      <Box className={classes.infoTileIcon}>
                        <PlaceIcon />
                      </Box>
                      <Box>
                        <Typography className={classes.infoTileLabel}>
                          Office
                        </Typography>
                        <Typography className={classes.infoTileText}>
                          201, Reliance Avans Bliss, Jayabheri Enclave,
                          Gachibowli, Hyderabad, Telangana 500032
                        </Typography>
                      </Box>
                    </a>

                    <a
                      href="mailto:contact@arawinz.com"
                      className={classes.infoTile}
                    >
                      <Box className={classes.infoTileIcon}>
                        <EmailIcon />
                      </Box>
                      <Box>
                        <Typography className={classes.infoTileLabel}>
                          Email
                        </Typography>
                        <Typography className={classes.infoTileText}>
                          contact@arawinz.com
                          <br />
                          arawinzsoft@gmail.com
                        </Typography>
                      </Box>
                    </a>

                    <Box className={classes.socialRow}>
                      <a
                        href="https://www.linkedin.com/company/arawinz-soft-solutions"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={classes.socialButton}
                        aria-label="LinkedIn"
                      >
                        <LinkedInIcon />
                      </a>
                      <a
                        href="https://www.youtube.com/@arawinzsoftsolutions"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={classes.socialButton}
                        aria-label="YouTube"
                      >
                        <YouTubeIcon />
                      </a>
                      <a
                        href="https://instagram.com/arawinzsoftsolutions/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={classes.socialButton}
                        aria-label="Instagram"
                      >
                        <InstagramIcon />
                      </a>
                      <a
                        href="https://www.facebook.com/Arawinz-Soft-Solutions-100197325544506/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={classes.socialButton}
                        aria-label="Facebook"
                      >
                        <FacebookIcon />
                      </a>
                    </Box>
                  </Box>
                </Fade>
              </Grid>
            </Grid>

            {/* Quote Section */}
            <Fade in={true} timeout={1400}>
              <Box className={classes.quoteSection}>
                <TypingQuote
                  text={`"At Arawinz, we prioritize understanding our clients' unique requirements and are dedicated to developing solutions that are not only scalable and secure but also innovative, user-friendly, and efficient. Our focus is on delivering top-quality, reliable, and adaptable products that meet the evolving demands of our clients."`}
                  className={classes.quoteText}
                />
                <Typography className={classes.quoteAuthor}>
                  - Arawinz Team
                </Typography>
              </Box>
            </Fade>
          </Container>
        </Box>
      )}
      
    </div>
  );
};

